import React, { lazy, useContext, useEffect, useState } from "react";
import styles from "./Step.module.css";
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
} from "@mui/material";
import StepsHeader from "../../../Components/StepsHeader/StepsHeader";
import property from "../../../assets/componentAssets/Property.png";
import NavButton from "./NavButton";
import { AppContext } from "../../../ContextApi/AppContext/AppContext";
import { directions, directionsGerm, monthYear } from "../utility/utils";
import { PatchApi, getApi } from "../../../Utility/network";
import PropertyAddress from "../../../assets/componentAssets/properttyAddress.png";
import PopUpInfo from "../../../Components/PopUpInfo/PopUpInfo";
import info from "../../../assets/componentAssets/info.svg";
import { arrayId, toggleValueInArray } from "../../../Utility/utils";
import wall1 from "../../../assets/componentAssets/wall1.svg";
import wall2 from "../../../assets/componentAssets/wall2.svg";
import wall3 from "../../../assets/componentAssets/wall3.svg";
import wall4 from "../../../assets/componentAssets/wall4.svg";
import { validatePostalCode } from "../utility/validations";
import { Elderly } from "@mui/icons-material";

function Step5() {
  const { state, setState, HandleErrorPop } = useContext(AppContext);
  const { language, needLanguage } = state;
  const style = { width: "100%" };
  const [errorsData, setErrorsData] = useState({});
  const [response, setResponse] = useState(false);
  const [disableNext, setDisableNext] = useState(true);

  const [infoText, setInfoText] = useState([]);
  const [pop, setPop] = useState(false);
  const [house, setHouse] = useState(false);
  const [active, setActive] = useState([]);
  const [windowsNew, setWindowsNew] = useState({
    structure_type: null,
    wall_details: [],
    window_details: [],
    active: [],
  });
  const [wall, setWall] = useState({
    index: null,
    id: null,
    image: "",
    length: null,
  });
  const { structure_detail } = state.walls;
  const { structure_type, wall_details } = structure_detail;
  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  useEffect(() => {
    setTimeout(() => {
      setDisableNext(false);
    }, 3000);
  });
  useEffect(() => {
    let window_details = [];
    window_details = wall_details?.map((item) => ({
      window_type_id: null,
      attached_wall_id: item.id,
      is_dimension_available_for_every_window: false,
      percentage_of_window_area_on_the_wall: 0,
    }));

    setWindowsNew((prev) => ({
      ...prev,
      structure_type,
      window_details,
      wall_details,
      active:
        wall_details && wall_details.length > 0
          ? [...prev.active, wall_details[0]]
          : [],
    }));
  }, [state.walls.structure_detail]);

  useEffect(() => {
    if (
      structure_detail?.wall_details &&
      structure_detail?.wall_details.length > 0
    ) {
      let filteredArray = structure_detail?.wall_details?.filter(
        (item) => item.index === 1
      );
      if (filteredArray.length > 0) {
        setWall(filteredArray[0]);
      }
    }
  }, [structure_detail]);

  const [submitData, setSubmit] = useState({
    street: "",
    postcode: "",
    location: "",
    direction_point: "",
    is_property_have_border_on_another_house: false,
  });
  useEffect(() => {
    if (isFiveDigitNumberFlexible(submitData.postcode)) {
      getPin(submitData.postcode);
    }
  }, [submitData.postcode]);
  function isFiveDigitNumberFlexible(input) {
    const numStr = String(input);
    return /^\d{5}$/.test(numStr);
  }
  const getPin = async (_pin) => {
    try {
      const responseData = await getApi(
        `/energy_consumption/postode_city/?postcode=${_pin}`
      );
      if (responseData && responseData.data.data.length > 0) {
        const firstObj = responseData.data.data[0];
        setSubmit((prev) => ({
          ...prev,
          ...(firstObj?.state && { location: firstObj?.state }),
        }));
      }
    } catch (error) {}
  };
  // New state variables for error messages

  //   "address": {

  //     "street": "sas",

  //     "postcode": 1212,

  //     "location": "mumbai",

  //     "direction_point": 1,

  //     "is_property_have_border_on_another_house": true,

  //     "attached_wall_id": 1

  // }
  useEffect(() => {
    if (state?.needData?.address) {
      const {
        street,
        postcode,
        location,
        direction_point,
        is_property_have_border_on_another_house,
        attached_wall_id,
        attached_wall,
      } = state?.needData?.address;
      setActive(attached_wall_id ? attached_wall_id : arrayId(attached_wall));
      setSubmit({
        street,
        postcode,
        location,
        direction_point,
        is_property_have_border_on_another_house,
      });
    }
  }, [state?.needData?.address]);
  const validateFields = () => {
    const errors = {};
    let hasErrors = false;
    const data = { ...submitData };

    // Iterate over each key in the object
    for (const key in data) {
      // Skip validation for 'is_property_have_border_on_another_house'
      if (key === "is_property_have_border_on_another_house") {
        continue;
      }
      if (
        key === "direction_point" &&
        structure_detail &&
        structure_detail?.structure_type == 5
      ) {
        continue;
      }

      if (Array.isArray(data[key])) {
        // Check if the array is empty
        if (data[key].length === 0) {
          errors[key] = needLanguage.required_field_error;
          hasErrors = true;
        } else {
          // Check nested arrays of objects like wall_details
          data[key].forEach((item, index) => {
            for (const subKey in item) {
              if (
                item[subKey] === null ||
                item[subKey] === "" ||
                item[subKey] === false
              ) {
                errors[`${key}[${index}].${subKey}`] =
                  needLanguage.required_field_error;
                hasErrors = true;
              }
            }
          });
        }
      } else if (
        data[key] === null ||
        data[key] === "" ||
        data[key] === false
      ) {
        // Check if the value is null, empty string, or false
        errors[key] = needLanguage.required_field_error;
        hasErrors = true;
      }
      if (key === "postcode") {
        const postcodeError = validatePostalCode(
          submitData?.postcode,
          needLanguage
        );
        if (postcodeError) {
          errors[key] = postcodeError;
          hasErrors = true;
        } else {
          delete errors[key]; // Remove the key if there is no error
        }
      }
    }

    // Log the errors (or handle them as needed)
    setErrorsData(errors);

    // Return true if there are errors
    return hasErrors;
  };

  const dataids = windowsNew?.active?.map((item) => item.id);

  const handleSubmit = async (num, type) => {
    try {
      if (type === "next") {
        const errors = validateFields();
        if (errors) return;
        const {
          street,
          postcode,
          location,
          direction_point,
          is_property_have_border_on_another_house,
        } = submitData;
        const attached_wall_id = active;
        const _data = {
          street,
          postcode,
          location,
          ...(structure_detail &&
            structure_detail?.structure_type != 5 && {
              direction_point:
                structure_detail && structure_detail?.structure_type != 5
                  ? direction_point
                  : "",
            }),
          is_property_have_border_on_another_house,
          attached_wall_id,
        };
        try {
          const postData = await PatchApi(`/energy_need/${state.needId}/`, {
            address: _data,
            language: language === "de" ? 2 : 1,
          });
          if (postData.status === 200 || postData.status === 201) {
            setState((prev) => ({
              ...prev,
              needPage: 6,
              needData: { ...prev.needData, address: _data },
              needFilledPage:
                prev.needFilledPage >= 6 ? prev.needFilledPage : 6,
            }));
          } else {
            throw Error("api failed");
          }
        } catch (error) {
          alert(error);
        }
      } else if (type === "prev") {
        const {
          street,
          postcode,
          location,
          direction_point,
          is_property_have_border_on_another_house,
        } = submitData;
        const _data = {
          street,
          postcode,
          location,
          direction_point,
          is_property_have_border_on_another_house,
        };
        setState((prev) => ({
          ...prev,
          needPage: prev.needPage - 1,
          needData: { ...prev.needData, address: _data },
        }));
      } else if (type === "save") {
        await getApi(`/energy_need/${state.needId}/generate_link/`);
        // navigate("/login");
        setResponse(true);
      }
    } catch (error) {
      HandleErrorPop(true);
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setSubmit((prev) => ({ ...prev, [name]: value }));
  };

  const handlePopUp = (data) => {
    setPop(true);
    setInfoText(data);
  };
  const popData = {
    house: [
      {
        heading: needLanguage.number_h,
        para1: needLanguage.number_d1,
        para2: needLanguage.number_d2,
      },
    ],
    postcode: [
      {
        heading: needLanguage.Postcode_h,
        para1: needLanguage.postcode_para_1,
        para2: needLanguage.postcode_para_2,
      },
    ],
  };
  return (
    <div>
      <div className={styles.con}>
        <StepsHeader
          image={PropertyAddress}
          heading={needLanguage.property_address}
          secPara={needLanguage.Please_provide_proper_information}
        />
        <div className={styles.fieldDetails}>
          <p className={styles.fieldName}>
            {needLanguage.house_number}
            <img
              src={info}
              style={{ cursor: "pointer" }}
              onClick={() => handlePopUp(popData?.house)}
            />
          </p>
          <TextField
            size="small"
            style={{ width: "100%" }}
            onChange={handleChange}
            name="street"
            value={submitData.street}
            error={errorsData?.street}
            helperText={errorsData?.street}
            onWheel={(e) => e.target.blur()}
          />
          <div className={styles.fieldCom}>
            <div className={styles.fields}>
              <p className={styles.fieldName}>
                {needLanguage.postcode}
                <img
                  src={info}
                  style={{ cursor: "pointer" }}
                  onClick={() => handlePopUp(popData?.postcode)}
                />
              </p>
              <TextField
                name="postcode"
                size="small"
                onChange={handleChange}
                value={submitData.postcode}
                style={{ width: "100%" }}
                error={errorsData?.postcode}
                helperText={errorsData?.postcode}
                onWheel={(e) => e.target.blur()}
              />
            </div>
            <div className={styles.fields}>
              <p className={styles.fieldName}>
                {needLanguage.location}
                <img
                  src={info}
                  style={{ cursor: "pointer" }}
                  onClick={() => handlePopUp(popData?.house)}
                />
              </p>
              <TextField
                name="location"
                onChange={handleChange}
                value={submitData.location}
                size="small"
                style={{ width: "100%" }}
                error={errorsData?.location}
                helperText={errorsData?.location}
                onWheel={(e) => e.target.blur()}
              />
            </div>
          </div>

          {structure_detail && structure_detail?.structure_type != 5 && (
            <div>
              <div className={styles.walld}>
                <div className={styles.wallt}>
                  <p className={styles.fieldName}>
                    {needLanguage.direction_object_point}
                  </p>
                  <FormControl
                    fullWidth
                    error={Boolean(errorsData.direction_point)}
                  >
                    <Select
                      size="small"
                      // value={submitData.material_id}
                      name="direction_point"
                      value={submitData.direction_point}
                      onChange={(e) => handleChange(e)}
                    >
                      {(language === "de" ? directionsGerm : directions).map(
                        (option) => (
                          <MenuItem key={option.id} value={option.id}>
                            {option.title}
                          </MenuItem>
                        )
                      )}
                    </Select>
                  </FormControl>
                </div>
                <div style={{ width: "30%", textAlign: "center" }}>
                  {state?.walls?.structure_detail?.structure_type == 1 ? (
                    <img src={wall1} />
                  ) : state?.walls?.structure_detail?.structure_type == 2 ? (
                    <img src={wall2} />
                  ) : state?.walls?.structure_detail?.structure_type == 3 ? (
                    <img src={wall3} />
                  ) : state?.walls?.structure_detail?.structure_type == 4 ? (
                    <img src={wall4} />
                  ) : (
                    ""
                  )}
                </div>
              </div>
              {errorsData?.direction_point && (
                <FormHelperText error={errorsData.direction_point}>
                  {errorsData?.direction_point}
                </FormHelperText>
              )}
              <div>
                <p className={styles.fieldName}>
                  {needLanguage.property_another_house}
                </p>
                <RadioGroup
                  name="is_property_have_border_on_another_house" // Name of the radio group
                  value={submitData.is_property_have_border_on_another_house} // Bind the state value
                  onChange={handleChange} // Handle value changes
                >
                  <div className={styles.Radio}>
                    <FormControlLabel
                      value={true}
                      control={<Radio />}
                      // disabled={true}
                      label={needLanguage.yes}
                    />
                    <FormControlLabel
                      value={false}
                      control={<Radio />}
                      // disabled={true}
                      label={needLanguage.no}
                    />
                  </div>
                </RadioGroup>
              </div>
              {(submitData?.is_property_have_border_on_another_house == true ||
                submitData?.is_property_have_border_on_another_house ==
                  "true") && (
                <div>
                  <p className={styles.fieldName}>{needLanguage?.wall}</p>

                  <div className={styles.mulWalls}>
                    {windowsNew?.wall_details?.map((item, index) => {
                      const value = item.length ? item.length : "";
                      const letter = String.fromCharCode(65 + index); // 65 is the ASCII code for 'A'
                      return (
                        <div
                          style={{
                            color: active.includes(item.id)
                              ? "#22A156"
                              : "white",
                            cursor: "pointer",
                            marginRight: "10px",
                            borderRadius: "10px",
                          }}
                          onClick={() => {
                            const newData = toggleValueInArray(active, item.id);
                            setActive(newData);
                          }}
                        >
                          {/* <p style={{ margin: "0px" }}>
                            {" "}
                            {needLanguage.wall} {letter}
                          </p> */}
                          <img
                            src={item.image}
                            style={{
                              width: "100px",
                              border: active.includes(item.id)
                                ? "1px solid #22a156"
                                : "1px solid white",
                              padding: "10px",
                              borderRadius: "10px",
                              boxShadow: active.includes(item.id)
                                ? "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px"
                                : "",
                            }}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      <NavButton
        handleSubmit={handleSubmit}
        response={response}
        disabled={disableNext}
      />
      {pop && (
        <PopUpInfo
          handleClose={() => setPop(false)}
          open={pop}
          data={infoText}
        />
      )}
    </div>
  );
}

export default Step5;
// "address": {

//   "street": "sas",

//   "postcode": 1212,

//   "location": "mumbai",

//   "direction_point": 1,

//   "is_property_have_border_on_another_house": true,

//   "attached_wall_id": 1

// }
